import React from 'react'
import { connect } from 'dva'
import { Button, Layout, notification } from 'antd'
import { Switch } from 'dva/router'
import ShowModal from "@/components/ShowModal"
import Icon from '@/components/Icon'
import Websocket from '@/components/Websocket'
import StompComponent from '@/components/StompComponent'
import { getWSUrl, voiceUrl, stompUrl } from '../utils/constant'
import moment from 'moment'
import PropTypes from "prop-types";
import styles from "./screenLayout.module.less";
import SetHtmlFontSize from "./SetHtmlFontSize";
import RealtimeAlarm from "@/routes/home/components/modal/realtimeAlarm"
import UnitSelectModal from "../routes/home/components/modal/unitSelectModal"
import HandleAlarmModal from "../routes/home/components/modal/handleAlarm"
import DeviceLabelModal from "../routes/home/components/center/components/tab/DeviceLabelModal"
import { handleAlarmContext2Props } from "../routes/home/decorator/context2Props"

notification.config({
    placement: 'bottomLeft',
    bottom: 10,
    duration: 3,
});

let timer = null
@handleAlarmContext2Props()
@connect(({ global, commonModel }) => ({
    user: global.user,
    unitSelectVisible: commonModel.unitSelectVisible,
    alarmInfo: commonModel.alarmInfo,
    deviceLabelInfo: commonModel.deviceLabelInfo,

}))
export default class ScreenLayout extends React.PureComponent {
    static childContextTypes = {
        //绑定处理告警的方法
        bindDeviceLabelAlarm: PropTypes.func,
    }
    state = {
        realtimeAlarmVisible: false,
        realtimeAlarmInfo: {}
    }

    componentDidMount() {
        this.props.dispatch({ type: 'global/getUserInfo' })
        this.props.dispatch({ type: "DICT/init", payload: { data: { size: 9999 } } });
    }


    handleChangeDevice(device) {
        const { deviceId, data } = device
        this.props.dispatch({ type: 'store/changeDeviceState', payload: { id: deviceId, state: data } })

    }

    /**
     * 打开通知提示
     */
    handleOpenNotice(type, message, key, info) {
        const { handleAlarm, dispatch } = this.props
        if (type === 'Alarm') {
            let config = {
                key,
                message: '告警通知',
                duration: 60 * 60,
                description: message,
                icon: <Icon type="ring" style={{ color: 'red' }} />,
                btn: [],
                onClick: (event) => {
                }
            }
            if (info.linkageExecuteCameraDeviceIdList && info.linkageExecuteCameraDeviceIdList.length > 0) {
                this.handleRealtimeAlarm(info);
                config.btn.push(
                    <Button className={styles.button} type="primary" onClick={() => this.handleRealtimeAlarm(info)}>
                        视频
                    </Button>
                )
            }
            if (info.planePosition) {
                config.btn.push(
                    <Button className={styles.button} type="primary" onClick={() => {
                        this.props.dispatch({ type: 'commonModel/changeDeviceLabelInfoVisible', data: { ...info, visible: true } });
                    }}>
                        平面图
                    </Button>
                )
            }
            config.btn.push(
                <Button className={styles.button} type="danger" onClick={() => {
                    handleAlarm({
                        alarmId: info.id,
                        deviceId: info.deviceId,
                        onSubmit: () => notification.close(key)
                    })
                }}>
                    处理
                </Button>
            )
            notification.error(config);
        } else if (type === 'Install') {
            notification.error({
                message: '报装通知',
                duration: 10,
                description: message,
                icon: <Icon type="info-circle" antd style={{ color: 'yellow', readState: 'UnRead' }} />
            })
        } else if (type === 'system') {
            notification.info({
                message: '系统通知',
                duration: 10,
                description: message
            })
        } else if (type === "NewWorkOrder") {
            notification.error({
                message: '工单通知',
                duration: 10,
                description: "您有一条新的工单信息",
                icon: <Icon type="info-circle" antd style={{ color: 'red', readState: 'UnRead' }} />
            })
        }
    }

    /**
     * 播放语音
     * @param {*} voice
     */
    handlePlayAudio(voice) {
        const audioEle = this.refs.audio
        audioEle.src = voiceUrl + voice
        audioEle.play()
    }

    /**
     * 处理接手到的ws的推送
     */
    handleMsg(data) {
        if (data === "pong") return;
        if (data !== '连接成功') {
            const obj = JSON.parse(data)
            this.pushMessage(obj)
        }
    }
    pushMessage(obj) {
        const isSound = true
        // const isSound = $$.getStore('isSound')
        if (obj.type === 'Alarm') {
            const info = JSON.parse(obj.data);
            const message = info.content + '  ' + moment(info.timestamp).format('HH:mm:ss');
            this.handleOpenNotice(obj.type, message, obj.timestamp, info);
            if (isSound) {
                this.handlePlayAudio(info.iflytekVoice);
            }
        } else if (obj.type === 'devStNewWorkOrderate') {
            const info = JSON.parse(obj.data)
            this.handleOpenNotice(obj.type, "您有一条新的工单信息", obj.timestamp);
            if (isSound) {
                this.handlePlayAudio(info.iflytekVoice);
            }
        } else if (obj.type === 'DeviceState') {
            const info = JSON.parse(obj.data);
            this.handleChangeDevice(info);
        }
    }


    /**
     * 维持ws心跳
     */
    handleOpen(ws) {
        if (!this.props.websockState) {
            this.props.dispatch({ type: 'global/websockStateChange', payload: true });
        }
        timer = setInterval(() => {
            ws.send("ping");
        }, 5000)
    }


    /**
     * 清除ws心跳
     */
    handleClose() {
        this.props.dispatch({ type: 'global/websockStateChange', payload: false })
        clearInterval(timer)
    }

    handleRealtimeAlarm = (info) => {
        this.setState({ realtimeAlarmVisible: true, realtimeAlarmInfo: info })
    }

    handleRealtimeAlarmClose = () => {
        this.setState({ realtimeAlarmVisible: false, realtimeAlarmInfo: {} })
    }

    render() {
        const { routerData, user, unitSelectVisible, alarmInfo, deviceLabelInfo } = this.props
        const { userInfo } = user || {}
        const { childRoutes } = routerData
        const { realtimeAlarmVisible, realtimeAlarmInfo } = this.state
        SetHtmlFontSize();
        const unitSelectProps = {
            visible: unitSelectVisible,
            onClose: () => this.props.dispatch({ type: 'commonModel/changeUnitSelectVisible' })
        }
        /** 警情处理 */
        const handleAlarmProps = {
            ...alarmInfo,
            onClose: () => this.props.dispatch({ type: 'commonModel/changeAlarmInfoVisible' })
        }

        const deviceLabelProps = {
            visible: deviceLabelInfo.visible,
            deviceLabelInfo,
            onClose: () => this.props.dispatch({ type: 'commonModel/changeDeviceLabelInfoVisible' })
        }
        return (
            <div className={styles.main}>
                <ShowModal {...deviceLabelProps} ><DeviceLabelModal /></ShowModal>
                <ShowModal {...handleAlarmProps} ><HandleAlarmModal /></ShowModal>
                <ShowModal {...unitSelectProps}><UnitSelectModal /></ShowModal>
                {realtimeAlarmVisible ?
                    <RealtimeAlarm visible={realtimeAlarmVisible} alarmInfo={realtimeAlarmInfo} onClose={this.handleRealtimeAlarmClose} />
                    : ``}
                <audio ref={'audio'} />
                {userInfo ? (
                    <StompComponent
                        url={stompUrl}
                        userName={userInfo.username}
                        onMessage={data => this.pushMessage(data)}
                    />
                ) : (
                    ''
                )}
                <Switch>{childRoutes}</Switch>
            </div>
        )
    }
}
